import { render, staticRenderFns } from "./ShowGantt.vue?vue&type=template&id=5aa2bb70&scoped=true&"
import script from "./ShowGantt.vue?vue&type=script&lang=js&"
export * from "./ShowGantt.vue?vue&type=script&lang=js&"
import style0 from "./ShowGantt.vue?vue&type=style&index=0&id=5aa2bb70&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa2bb70",
  null
  
)

export default component.exports